import { render } from "./FooterView.vue?vue&type=template&id=8d65c9e2&ts=true"
import script from "./FooterView.vue?vue&type=script&lang=ts"
export * from "./FooterView.vue?vue&type=script&lang=ts"

import exportComponent from "G:\\wamp\\www\\vahanwale\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__